import { isNil, last } from 'lodash';

/** "Alex R." for Alex Rivera; empty until the person loads. */
export function getShortName(user: { fullName: string } | undefined): string {
  if (isNil(user)) {
    return '';
  }
  const [firstName = '', ...otherNames] = user.fullName.split(' ');
  const lastInitial = last(otherNames)?.[0];
  if (isNil(lastInitial)) {
    return firstName;
  }
  return `${firstName} ${lastInitial}.`;
}
